import { useState } from "react";
import "./App.css";
import Logo from "./components/Logo";
import Form from "./components/Form";
import PickingList from "./components/PickingList";
import States from "./components/States";

function App() {
  const [data, setData] = useState([]);

  function handleDeleteItem(id) {
    setData((items) => items.filter((item) => item.id !== id));
  }

  function handleToggleItem(id) {
    setData((items) =>
      items.map((item) =>
        item.id === id ? { ...item, picked: !item.picked } : item
      )
    );
  }

  function handleClearList() {
    if (data.length === 0) {
      return alert("You did not have any items in list for clearing list");
    }
    const confirmed = window.confirm(
      "Are you sure to delete all items of list "
    );

    if (confirmed) setData([]);
  }

  return (
    <div className="flex flex-col items-center w-full">
      <Logo />
      <Form setData={setData} />
      <PickingList
        data={data}
        onDeleteItem={handleDeleteItem}
        onToggleItem={handleToggleItem}
        onClearList={handleClearList}
      />
      <States items={data} />
    </div>
  );
}

export default App;
